import { useState, useEffect } from 'react';
import axios from 'axios';

const apiParkingBase = process.env.BUN_PUBLIC_PARKING_API_BASE;

interface ParkingLocationConfig {
    maxGeneralFiles: number;
    maxPlateNumbers: number;
    concurrentUploads: number;
    maxFileSizeMB: number;
    allowedTypes: string[];
    enableRegistration: boolean;
    pdpaFileUrl: string;
    tncFileUrl: string;
}

const defaultConfig: ParkingLocationConfig = {
    maxGeneralFiles: 1,
    maxPlateNumbers: 5,
    concurrentUploads: 2,
    maxFileSizeMB: 20,
    allowedTypes: ['image/', 'application/pdf'],
    enableRegistration: false,
    pdpaFileUrl: '',
    tncFileUrl: '',
};

export function useParkingLocationConfigs(locationId: string | null, formType: 'resident' | 'company') {
    const [config, setConfig] = useState<ParkingLocationConfig>(defaultConfig);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!locationId) {
            setLoading(false);
            return;
        }
        axios.get(`${apiParkingBase}/api/public/parking-locations/settings`, {
            params: { id: locationId }
        })
        .then(res => {
            const data = res.data;
            setConfig({
                ...defaultConfig,
                maxPlateNumbers: (formType === 'resident' ? data.max_number_resident_vehicle : data.max_number_plate) || 5,
                enableRegistration: data.enable_registration || false,
                maxFileSizeMB: data.max_file_size_mb || 20,
                pdpaFileUrl: (formType === 'resident' ? data.resident_pdpa_file_url : data.company_pdpa_file_url) || '',
                tncFileUrl: (formType === 'resident' ? data.resident_tnc_file_url : data.company_tnc_file_url) || '',
            });
        })
        .catch(() => setConfig(defaultConfig))
        .finally(() => setLoading(false));
    }, [locationId, formType]);

    return { config, loading };
}
